import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SoSchedulesPageRBAC = {
  pageID: 'c0c1adb05341b352040385fdeddaba81',
  elementID: {
    BtnDownloadCsv: '3862eb7c90cb8aa63aa20fad796358f5',
    BtnUploadSchedule: '9481b138efadd4b7a4b6dd0906098cb7',
    BtnDeleteScheduleItem: '4bce904e160fec520aae0f51608beecc',
    BtnDeleteAllSchedules: '35af839e3b3b3cb1d068595e31b6649f',
  },
} as const

export const useRBACSoSchedulesPage = createUseRBAC(SoSchedulesPageRBAC.elementID)

export type UseRBACSoSchedulesPageType = ReturnType<typeof useRBACSoSchedulesPage>
